import {
  CHANGE_TEST_SCENARIOS,
  FETCH_TEST_CAMPAIGN_RESULTS_ASYNC,
  SEND_TRY_IT_OUT_ASYNC,
  SET_ERROR,
} from './constants'

const fetchTestCampaignResults = () => ({
  type: FETCH_TEST_CAMPAIGN_RESULTS_ASYNC.INITIATE,
})
export const fetchTestCampaignResultsSuccess = (data) => ({
  type: FETCH_TEST_CAMPAIGN_RESULTS_ASYNC.SUCCESS,
  payload: data,
})
export const fetchTestCampaignResultsError = (error) => ({
  type: FETCH_TEST_CAMPAIGN_RESULTS_ASYNC.ERROR,
  error,
})

export const sendTryItOutSuccess = (data) => ({
  type: SEND_TRY_IT_OUT_ASYNC.SUCCESS,
  payload: { data },
})
export const sendTryItOutError = (error) => ({
  type: SEND_TRY_IT_OUT_ASYNC.ERROR,
  error,
})

const changeTestSelectedScenarios = (selectedScenarios) => ({
  type: CHANGE_TEST_SCENARIOS,
  payload: { selectedScenarios },
})

const setError = (value) => ({
  type: SET_ERROR,
  payload: { value },
})

export default {
  fetchTestCampaignResults,
  changeTestSelectedScenarios,
  setError,
}
